<template>
    <div v-if="announcementData">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div v-if="!edit" id="announcementHolder" class="rcorners2">
                        <h3 id="announcementTitle">{{ announcementData.anakoinwshLek }}</h3>

                        <div id="content-holder" v-html="announcementData.content"></div>
                    </div>
                </div>
            </div>
            <br>
            <div v-if="!edit" class="row">
                <div class="col-md-12 text-md-left">
                    <h5>Συνημμένα:</h5>
                </div>
                <div class="col-md-12 text-md-center">
                    <div class="btn-group">
                        <button type="button" class="btn btn-warning" v-for="a in announcementData.attachments"
                                v-on:click="downloadAttachment(a.attachmentId,a.attacmentName)" :key="a.attachmentId">
                            {{ a.attacmentName }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <EditAnnouncement v-if=edit ref="editAnnouncement" :content="announcementData.content"
                          :id="id"
                          :announcement-data="announcementData"
                          title="Επεξεργασία ανακοίνωσης"
                          @save:success="successSave"
        />
        <div id="metaDataHolder">
            <div class="container">
                <hr>
                <div class="d-flex justify-content-between">
                    <div v-if="!edit">
                        <h5>Ομάδες</h5><br>
                        <ul class="groupsList" v-if="announcementData.groups.length > 0">
                            <li v-for="(team, index) in announcementData.groups" :key="index">
                                {{ team.onoma }}
                            </li>
                        </ul>
                        <h6 v-else>Δεν υπάρχει διαθέσιμη ομάδα</h6>
                    </div>
                    <div>
                        <h5>Κατάσταση</h5><br>
                        <h3>{{getStatus}}</h3>
                    </div>
                    <div>
                        <h5>Ημερομηνία Δημιουργίας</h5><br>
                        <h3>{{ formatDate(announcementData.anakoinwshDate) }}</h3>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div v-if="role === 'ROLE_ADMIN' || role === 'ROLE_MANAGER' || role==='ROLE_SXHMATISMOS'" style="margin:20px">
                <div style="align: center" class="row">
                    <button v-if="!edit && hasEditAccess" class="btn btn-primary" type="button"
                            v-on:click="editAnnouncement">Επεξεργασία
                    </button>
                    <button v-if="edit && hasEditAccess" class="btn btn-primary" type="button"
                            v-on:click="saveEditedAnnouncement">Αποθήκευση Αλλαγών
                    </button>
                    <button v-if="edit && hasEditAccess" class="btn btn-danger" type="button"
                            v-on:click="discardChanges">Ακύρωση
                    </button>
                    <button v-if="!edit && role === 'ROLE_ADMIN'" class="btn btn-danger" type="button"
                            v-on:click="deletePermissionModal">Απόρριψη
                    </button>
                    <button v-if="!edit" class="btn btn-primary" type="button" v-on:click="print">Εκτύπωση</button>
                    <button
                        v-if="!edit && role === 'ROLE_ADMIN' && announcementData.anakoinwshStatus!= 'PUBLISHED'"
                        class="btn btn-success" type="button" v-on:click="approveAnnouncement(id)">Έγκριση
                    </button>
                </div>
                <br>
            </div>
        </div>

        <Message v-if="msgVisible" :message="message" :msgClass="msgClass"></Message>

        <div id="toPrint" style="display:none;">
            <div id="printAnnouncementTitle"></div>
            <div id="printAnnouncementContent"></div>
            <div id="announcementMetadata"></div>
        </div>

        <!-- The Modal -->
        <div class="modal fade" id="printPreviewModal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Εκτύπωση Ανακοίνωσης</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body" id="modal-announcement-holder"></div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" v-on:click="sendToPrint">Εκτύπωση</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Ακύρωση</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- The Modal -->
        <div class="modal fade" id="deleteAnnouncementModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Απόρριψη Ανακοίνωσης</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body" id="modal-delete-msg-holder">Είστε σίγουροι ότι θέλετε να διαγράψετε την
                        ανακοίνωση με τίτλο: {{ announcementData.anakoinwshLek }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" v-on:click="deleteAnnouncement">Απόρριψη</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Ακύρωση</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Editor from "../../components/Editor";
import UploadFile from '../../components/UploadFile';
import Message from '../../components/Message';
import CreateTeam from '@/components/teams/CreateTeam';
import EditAnnouncement from '@/components/EditAnnouncement';
import {Structs as structs} from "@/structs";

export default {
    name: "ViewAnnouncements",
    components: {
        EditAnnouncement,
        Editor,
        UploadFile,
        Message,
        CreateTeam
    },
    data() {
        return {
            id: "",
            announcementData: structs.AnnouncementData(),
            contentBeforeEdit: '',
            groupsBeforeEdit: '',
            titleBeforeEdit: '',
            attachmentsBeforeEdit: [],
            edit: false,
            message: '',
            msgClass: '',
            msgVisible: false,
        }
    },
    mounted() {
        let url = window.location.href;
        this.id = url.split("/").pop();
        this.viewAnnouncement(this.id);
    },
    computed: {
        getStatus: function () {
            switch (this.announcementData.anakoinwshStatus) {
                case "PUBLISHED":
                    return "Δημοσιευμένη"
                case "PENDING":
                    return "Προς έγκριση"
            }
        },
        role: function () {
            return this.$store.getters.userRole;
        },
        hasEditAccess: function () {
            return Number(this.$store.getters.meeResponsible) === Number(this.announcementData.moepKwd)
                || Number(this.$store.getters.meeResponsible) === Number(this.announcementData.sximatismoiKwd)
                || this.role === 'ROLE_ADMIN';
        },
        isAddNewAttachment: function () {
            return this.announcementData.attachments == null || this.$validator.isEmptyObject(this.announcementData.attachments);
        }
    },
    methods: {
        setMsg(status, msg) {
            this.message = msg;
            this.msgClass = status;
            this.msgVisible = true;
        },
        viewAnnouncement: function (id) {
            this.$store.dispatch('loading');
            this.$http.get("/announcements/" + id)
                .then((response) => {
                    this.announcementData.content = response.data.content;
                    this.announcementData.groups = response.data.groups;
                    this.announcementData.attachments = response.data.attachments;
                    this.announcementData.moepKwd = response.data.announcement.moepKwd;
                    this.announcementData.anakoinwshLek = response.data.announcement.anakoinwshLek;
                    this.announcementData.anakoinwshDate = response.data.announcement.anakoinwshDate;
                    this.announcementData.anakoinwshStatus = response.data.announcement.anakoinwshStatus;
                    this.announcementData.groupSizes = response.data.groupSizes;
                    this.announcementData.sximatismoiKwd = response.data.announcement.sximatismoiKwd;
                })
                .catch((e) => {
                    console.error(e);
                    this.$router.push('login');
                })
                .finally(() => this.$store.dispatch('stop_loading'));
        },
        editAnnouncement: function () {
            this.groupsBeforeEdit = [...this.announcementData.groups]
            this.contentBeforeEdit = this.announcementData.content;
            this.titleBeforeEdit = this.announcementData.anakoinwshLek;
            this.attachmentsBeforeEdit = [...this.announcementData.attachments];
            this.edit = true;
        },
        discardChanges: function () {
            this.edit = false;
            this.announcementData.content = this.contentBeforeEdit;
            this.announcementData.anakoinwshLek = this.titleBeforeEdit;
            this.announcementData.attachments = [...this.attachmentsBeforeEdit];
            this.announcementData.groups = [...this.groupsBeforeEdit];
        },
        print() {
            // Pass the element id here
            let docHTML = "<div>";
            docHTML += "<h3 class=\"text-center\">" + this.announcementData.anakoinwshLek + "</h3><br>";
            docHTML += this.announcementData.content;
            docHTML += "<br><br><table class=\"table table-bordered\"><thead class=\"thead-dark\"><th>Ομάδα</th><th>Αριθμός Εφέδρων</th></thead><tbody>";

            for (let key in this.announcementData.groupSizes) {
                let row = "<tr>";
                row = row + "<td>" + key + "</td>" + "<td>" + this.announcementData.groupSizes[key] + "</td></tr>";
                docHTML += row;
            }

            docHTML += "</tbody></table>";
            docHTML += "</div>";

            document.getElementById('modal-announcement-holder').innerHTML = docHTML;
            $('#printPreviewModal').modal('show');
        },
        sendToPrint: function () {
            this.$htmlToPaper('modal-announcement-holder');
            $('#printPreviewModal').modal('hide');
        },
        deletePermissionModal: function () {
            $('#deleteAnnouncementModal').modal('show');
        },
        deleteAnnouncement: function () {
            $('#deleteAnnouncementModal').modal('hide');
            this.$store.dispatch('loading');
            let that = this;
            this.$http.post("/announcements/" + this.id + "/delete")
                .then((response) => {
                    let resp = response.data;
                    this.setMsg('success', resp.message);

                    if(that.announcementData.sximatismoiKwd && that.announcementData.sximatismoiKwd!=null) 

                        window.setTimeout(function () {
                            that.$router.push({'name': 'validate-announcement-deps'});
                        }, 2000);
                       
                    else  

                        window.setTimeout(function () {
                            that.$router.push({'name': 'validate-announcement-me'});
                        }, 2000);
                })
                .catch((e) => {
                    console.error(e);
                    let resp = e.response;
                    this.setMsg('danger', (resp.data.errorMessage) ? resp.data.errorMessage : resp.statusText)
                })
                .finally(() => this.$store.dispatch('stop_loading'));

        },
        approveAnnouncement: function (announcementID) {
            this.$store.dispatch('loading');

            let that = this;
            this.$http.post("/announcements/" + announcementID + "/approve", {})
                .then((response) => {
                    let resp = response.data;
                    this.setMsg('success', resp.message);
                    
                    if(that.announcementData.sximatismoiKwd && that.announcementData.sximatismoiKwd!=null) 

                        window.setTimeout(function () {
                            that.$router.push({'name': 'validate-announcement-deps'});
                        }, 2000);
                       
                    else  

                        window.setTimeout(function () {
                            that.$router.push({'name': 'validate-announcement-me'});
                        }, 2000);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => this.$store.dispatch('stop_loading'));
        },
        saveEditedAnnouncement: function () {
            this.$refs.editAnnouncement.save();
        },
        successSave: function () {
            this.viewAnnouncement(this.id);
            this.edit = false;
        },
        downloadAttachment: function (attachmentID, attachmentName) {
            let url = "/announcements/download/" + attachmentID;
            this.$store.dispatch('loading');
            this.$http({
                url: url,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                // this.$store.commit('set_token', response.headers.jwt);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", attachmentName);
                this.$store.dispatch('stop_loading');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }).catch((e) => {
                console.error(e);
                this.$store.dispatch('stop_loading');
            });
        },
        formatDate: function (date) {
            return date.split("T")[0].split("-").reverse().join("/");
        },
    }
}
</script>

<style scoped>

.btn {
    margin-left: 10px;
}

.rcorners2 {
    border-radius: 6px;
    border: 1px solid #000000;
    padding: 40px;
    background-color: #f2f2f2;
    /*width: 200px;
    height: 150px;*/
}

ul.groupsList {
    list-style: none;
}

ul.groupsList li {
    font-weight: 900;
    font-size: 1.1rem;
}

ul.groupsList li::before {
    content: "-";
}

#announcementTitle {
    margin-bottom: 30px;
}
</style>